import React from 'react';
import OnboardingCarousel from './onboarding-carousel';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import routes from '../../../routes';

const OnboardingCarouselRouter = (props) => {
    const {tripboardCreationStarted, tripboards} = props;
    const uuid = tripboards && tripboards[0] && tripboards[0].uuid;
    if (uuid && tripboardCreationStarted) {
        return (
            <Redirect to={`${routes.TRIPBOARD}/${uuid}`} push/>
        );
    }

    return <OnboardingCarousel {...props} />;
};

const mapStateToProps = (state) => (
    {
        tripboardCreationStarted: state && state.onboarding && state.onboarding.tripboardCreationStarted
    }
);

export default connect(mapStateToProps)(OnboardingCarouselRouter);



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/onboarding-carousel/onboarding-carousel-router.js